import * as React from 'react';

import AppState from '@webapp/store/state';
import { connect } from 'react-redux';
import LoadingCtrl from '../../loading';
import styled from 'styled-components';

interface TrackLoadingCtrlProps {
  className?: string;
  trackId: string;
}

interface StoreProps {
  isLoading: boolean;
}

const mapStateToProps = (state: AppState, props: TrackLoadingCtrlProps) => {
  const asset = state.assets.statuses[props.trackId];

  return {
    isLoading: !asset?.validationDone,
  };
};

export const TrackLoadingCtrl: React.FC<TrackLoadingCtrlProps & StoreProps> = (
  props
) => {
  return props.isLoading ? (
    <div className={props.className}>
      <LoadingCtrl className="loader" loading={props.isLoading} />
    </div>
  ) : null;
};

export default connect(mapStateToProps)(styled(TrackLoadingCtrl)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 100vh;
  background: rgba(0, 0, 0, 0.1);
  z-index: 999;

  .loader {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`);
